import React from 'react';
import PropTypes from 'prop-types';

// Components
// import { Button } from 'junto-ui';
import Avatar from '../Avatar';

// Styles
import * as S from './styles';

const Profile = ({ user }) =>
  user ? (
    <S.Profile data-testid="profile">
      <S.Data>
        <S.Name data-testid="profile-name">{user.userName}</S.Name>
        <S.Email data-testid="profile-email">{user.email}</S.Email>

        {/*
          This button won't be used at this moment, but soon it'll be necessary
          <Button size="small" variant="outlined">Preferências de conta</Button>
        */}
      </S.Data>

      <Avatar name={user.userName} />
    </S.Profile>
  ) : null;


Profile.propTypes = {
  user: PropTypes.object
};

export default Profile;